import * as React from 'react';

function SvgNotifications(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M5.605 16.777c.971 0 2.569-.09 4.729-.487a2.658 2.658 0 01-2.491 1.744c-.95 0-1.784-.504-2.254-1.257h.016zm12.197-5.541c.177.908-.46 1.712-1.895 2.39-.786.37-2.533 1.076-5.418 1.638-2.226.432-3.857.531-4.883.531-.305 0-.557-.009-.756-.02-1.583-.09-2.476-.598-2.652-1.507-.268-1.376.156-1.907.858-2.787l.185-.232c.473-.601.658-1.191.355-2.748-.677-3.485.893-5.867 4.307-6.535 3.416-.659 5.764.96 6.442 4.446.302 1.557.695 2.034 1.36 2.413l.258.147c.98.553 1.571.887 1.84 2.264z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgNotifications;
